import { useEffect, useRef, useState } from "react";
import { EVENTO_CONFIRMAR, registrarVentanaDeConfirmacion } from "../avisos";

// Ventana "¿Estás seguro?" de toda la app (ver confirmar() en shared/avisos.js).
function Confirmacion() {
  const [pregunta, setPregunta] = useState(null);
  const aceptar = useRef(null);

  useEffect(() => {
    registrarVentanaDeConfirmacion(true);
    const alPreguntar = (evento) => setPregunta(evento.detail);
    window.addEventListener(EVENTO_CONFIRMAR, alPreguntar);
    return () => {
      registrarVentanaDeConfirmacion(false);
      window.removeEventListener(EVENTO_CONFIRMAR, alPreguntar);
    };
  }, []);

  useEffect(() => {
    if (!pregunta) return undefined;
    aceptar.current?.focus();
    const alPresionar = (e) => e.key === "Escape" && responder(false);
    window.addEventListener("keydown", alPresionar);
    return () => window.removeEventListener("keydown", alPresionar);
  });

  if (!pregunta) return null;

  function responder(respuesta) {
    pregunta.resolver(respuesta);
    setPregunta(null);
  }

  return (
    <div
      className="ventana-fondo fixed inset-0 z-[70] flex items-center justify-center bg-black/80 p-4 backdrop-blur-sm"
      role="alertdialog"
      aria-modal="true"
      aria-labelledby="confirmacion-titulo"
      aria-describedby="confirmacion-mensaje"
      onMouseDown={(e) => e.target === e.currentTarget && responder(false)}
    >
      <div className="ventana-panel w-full max-w-md rounded-2xl border border-white/10 bg-zinc-950 p-6 sm:p-8">
        <h3 id="confirmacion-titulo" className="titulo-ventana mb-3">{pregunta.titulo}</h3>
        <p id="confirmacion-mensaje" className="whitespace-pre-line text-sm text-gray-300">{pregunta.mensaje}</p>
        <div className="mt-8 flex flex-wrap justify-end gap-2">
          <button type="button" onClick={() => responder(false)} className="btn-fantasma">Cancelar</button>
          <button
            ref={aceptar}
            type="button"
            onClick={() => responder(true)}
            className={pregunta.peligro ? "btn bg-rose-500 text-white hover:bg-rose-400" : "btn-primario"}
          >
            {pregunta.aceptar}
          </button>
        </div>
      </div>
    </div>
  );
}

export default Confirmacion;
